import 'react-loading-skeleton/dist/skeleton.css'
import Skeleton from 'react-loading-skeleton';
import { Group } from '../';

export const PlaidSkeletonLoader = () => {
  return (
    <Group direction={'row'} className={'skeleton-loader'}>
      <Group direction={'row'} style={{ height: '50px', width: 'auto' }}>
        <Group direction={'column'} style={{ height: 'inherit' }}>
          <Skeleton width={'210px'} height={'50px'} />
        </Group>
        <Group
          direction={'column'}
          style={{ height: 'inherit', marginLeft: '10px' }}
        >
          <Skeleton width={'160px'} height={'50px'} />
        </Group>
        <Group
          direction={'column'}
          style={{ height: 'inherit', marginLeft: '20px' }}
        >
          <Skeleton width={'200px'} height={'50px'} />
        </Group>
      </Group>
    </Group>
  );
};
